import { RiAccountCircleLine } from 'react-icons/ri';
const AccountIcon = () => <RiAccountCircleLine size={20} />;

export default AccountIcon;
